import { render, staticRenderFns } from "./ModelsBtn.vue?vue&type=template&id=60807ad0&"
import script from "./ModelsBtn.vue?vue&type=script&lang=js&"
export * from "./ModelsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports